<script setup>
import { ref } from "vue";

const props = defineProps({
  title: String,
  img: String,
  label: String,       // new, popular, trending...
  video: String, 
  game: Object, // truyền nguyên object game 
});

// Hover state
const hovering = ref(false);

// Emit mở popup Info
const emit = defineEmits(["view-detail"]);
</script>

<template>
  <div
    class="game-card"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
	
	@click="emit('view-detail', props.game)"
  >
    <!-- LABEL LEFT TOP -->
    <div v-if="label" class="tag-left">
      {{ label }}
    </div>

    <!-- INFO BUTTON RIGHT TOP -->
    <div class="info-btn" @click.stop="emit('view-detail', props.game)">
      ⓘ
    </div>

    <!-- IMAGE OR VIDEO -->
    <img
      v-if="!hovering || !video"
      :src="img"
      class="thumb"
      draggable="false"
    />

    <video
      v-else
      class="thumb"
      autoplay
      muted
      loop
      playsinline
      :src="video"
    ></video>

    <!-- TITLE ON HOVER -->
    <div v-show="hovering" class="hover-title">
      {{ title }}
    </div>
  </div>
</template>

<style scoped>
.game-card {
  position: relative;
  background: #2b2b2b;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: 0.25s;
}
.game-card:hover {
  transform: translateY(-5px);
}

/* Thumbnail (img/video) */
.thumb {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

/* Left tag */
.tag-left {
  position: absolute;
  top: 8px;
  left: 8px;
  background: #59ff9e;
  color: #000;
  font-size: 12px;
  padding: 3px 7px;
  border-radius: 6px;
  font-weight: 600;
  z-index: 5;
}

/* Info button */
.info-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: rgba(0,0,0,0.55);
  border-radius: 50%;
  font-size: 14px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 6;
  backdrop-filter: blur(4px);
}
.info-btn:hover {
  background: rgba(255,255,255,0.7);
  color: #000;
}

/* Title hover */
.hover-title {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 8px;
  background: rgba(0,0,0,0.55);
  text-align: center;
  font-size: 15px;
  font-weight: 550;
  backdrop-filter: blur(5px);
}
</style>
